module.exports = __webpack_public_path__ + "static/media/builders.5b0c12e5.png";